









import { Component, Mixins } from "vue-property-decorator";
import {
  ModelEditableMixin,
} from "../../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../../base/components/system/selectors/mixins";
import { FormatStructureEditableMixin } from "../../mixins";
import { WriteMethodKinds } from "../../../../../domain/editableFormat";

@Component({
  components: {
    OptionDropDownSelector,
  },
})
export default class FormatPropertyWorkflowEditTool extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  writeMethodTypeOptions: StandardOption<WriteMethodKinds>[] = [
    new StandardOption<WriteMethodKinds>("未指定", WriteMethodKinds.Unknown),
    new StandardOption<WriteMethodKinds>("直接記載（確認）", WriteMethodKinds.Direct),
    new StandardOption<WriteMethodKinds>("ワークフロー（確認）", WriteMethodKinds.Workflow),
    new StandardOption<WriteMethodKinds>("直接記載（警告）", WriteMethodKinds.DirectOnly),
    new StandardOption<WriteMethodKinds>("ワークフロー（警告）", WriteMethodKinds.WorkflowOnly),
  ];
}
